import type { ReactNode } from "react"
import FormError from "./FormError"

type Props = {
  path: string
  children: ReactNode
}

export default function FormSubtreeError({ path, children }: Props) {
  return (
    <>
      {children}
      <FormError path={path} className="mt-4" />
    </>
  )
}
